import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getRETURNSTableStructure";
export const UPDATE_TABLE_DATA = "getRETURNSTableData";
export const EXPORT_TABLE_DATA = "exportRETURNSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setRETURNSTableStructure";
export const SET_TABLE_DATA = "setRETURNSTableData";
export const SET_TABLE_FILTER = "setRETURNSTableFilter";
// export const SET_FILTER_CHANGE = "setRETURNSFilterChange";
export const SET_TABLE_PAGE = "setRETURNSTablePage";
export const SET_TABLE_PERPAGE = "setRETURNSTablePerPage";
export const SET_TABLE_SORTBY = "setRETURNSTableSortBy";
export const SET_TABLE_SORTORDER = "setRETURNSTableSortOrder";
export const SET_EXPORT_LINK = "setRETURNSExportLink";
export const SET_ITEM_FOR_UPDATE = "setRETURNSItemForUpdate";
export const SET_CREATE_RETURN_TYPE = "setRETURNCreateReturnType";
export const SET_SERVER_DATA = "setRETURNServerData";
export const SET_COLLECTION_ADDRESS_TYPE = "setRETURNSCollectionAddressType";
export const SET_DESTINATION_ADDRESS_TYPE = "setRETURNSDestinationAddressType";
export const SET_SELECTED_CUSTOMER = "setRETURNSSelectedCustomer";
export const SET_INTERNAL_ORDER_SKUS = "setRETUNRSInternalOrderSkus";
export const SET_ACTION_TYPE = "setRETURNSActionType";
export const SET_EDIT_DATA = "setRETURNSEditData";
export const SET_EDITED_SKU = "setRETURNSEditedSku";
export const SET_CUSTOM_COLLECTION_ADDRESS =
  "setRETURNSCustomCollectionAddress";
export const SET_CUSTOM_DESTINATION_ADDRESS =
  "setRETURNSCustomDestinationAddress";
export const SET_INTERNAL_ORDER_RELATED_SKUS =
  "setRETURNSInternalOrderRelatedSkus";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  item_for_update: null,
  create_return_type: "",
  serverData: {},
  collection_address_type: null,
  destination_address_type: 2,
  selected_customer: null,
  internal_order_skus: null,
  action_type: "create",
  edit_data: null,
  edited_sku: null,
  custom_collection_address: {},
  custom_destination_address: {},
  internal_order_related_skus: [],
};

const getters = {
  /**
   * for table title, description
   * */
  getRETURNSTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getRETURNSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getRETURNSPrintTypes(state) {
    return state.table_structure.print_labels;
  },
  getRETURNSTableState(state) {
    return state.table_state;
  },
  getRETURNSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getRETURNSTableFilters(state) {
    return state.table_structure.filters;
  },

  getRETURNSTableData(state) {
    return state.table_data.data;
  },

  getRETURNSExportUrl(state) {
    return state.export_link;
  },
  getRETURNSCreateReturnType(state) {
    return state.create_return_type;
  },
  getRETURNSServerData(state) {
    return state.serverData;
  },
  getRETURNSSelectedCollectionAddressType(state) {
    return state.collection_address_type;
  },
  getRETURNSSelectedDestinationAddressType(state) {
    return state.destination_address_type;
  },
  getRETURNSSelectedCustomer(state) {
    return state.selected_customer;
  },
  getRETURNSInternalOrdersSkus(state) {
    return state.internal_order_skus;
  },
  getRETURNSActionType(state) {
    return state.action_type;
  },
  getRETURNSEditData(state) {
    return state.edit_data;
  },
  getRETURNSCarriers(state) {
    return state.table_structure.carriers;
  },
  getRETURNSCarrierAccounts(state) {
    return state.table_structure.carrier_accounts;
  },
  getRETURNSDestinationAddressType(state) {
    return state.table_structure.destination_address_types;
  },
  getRETURNSDestinationCustomerAddresses(state) {
    return state.table_structure.customer_addresses;
  },
  getRETURNSDestinationCarrierAddersses(state) {
    return state.table_structure.carrier_addresses;
  },
  getRETURNSDestinationWarehouses(state) {
    return state.table_structure.warehouses;
  },
  getRETURNSCustomCollectionAddress(state) {
    return state.custom_collection_address;
  },
  getRETURNSCustomDestinationAddress(state) {
    return state.custom_destination_address;
  },
  getRETURNSInternalOrderRelatedSkus(state) {
    return state.internal_order_related_skus;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/shipping/returns_management")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/shipping/returns_management/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/shipping/returns_management/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_ITEM_FOR_UPDATE](state, item) {
    state.item_for_update = item;
  },
  [SET_CREATE_RETURN_TYPE](state, type) {
    state.create_return_type = type;
  },
  [SET_SERVER_DATA](state, data) {
    state.serverData = data;
  },
  [SET_COLLECTION_ADDRESS_TYPE](state, type) {
    state.collection_address_type = type;
  },
  [SET_DESTINATION_ADDRESS_TYPE](state, type) {
    state.destination_address_type = type;
  },
  [SET_SELECTED_CUSTOMER](state, customer) {
    state.selected_customer = customer;
  },
  [SET_INTERNAL_ORDER_SKUS](state, details) {
    state.internal_order_skus = details;
  },
  [SET_ACTION_TYPE](state, type) {
    state.action_type = type;
  },
  [SET_EDIT_DATA](state, data) {
    state.edit_data = data;
  },
  [SET_EDITED_SKU](state, data) {
    state.edited_sku = data;
  },
  [SET_CUSTOM_COLLECTION_ADDRESS](state, data) {
    state.custom_collection_address = data;
  },
  [SET_CUSTOM_DESTINATION_ADDRESS](state, data) {
    state.custom_destination_address = data;
  },
  [SET_INTERNAL_ORDER_RELATED_SKUS](state, skus) {
    state.internal_order_related_skus = skus;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
